import { useQuery } from '@tanstack/react-query'
import AXIOS_INSTANCE from '../api/axiosInstance'
import { IcdsResMock } from '../types/icd.type'

type props = {
  query?: string // Search query for icds
}

export const useIcds = (arg?: props) => {
  const query = arg?.query
  const { data: AllIcds } = useQuery({
    queryFn: async () => {
      let endpoint = 'icd_codes'
      if (query) endpoint = `${endpoint}?query=${query}`
      // Fetch icds from API
      const { data } = await AXIOS_INSTANCE.get<IcdsResMock>(endpoint)
      return data.data
    },
    queryKey: ['icds', { query }]
  })

  return { AllIcds }
}
